// dependencies
import { CreateProcess } from "redux-process";

export const GetAsyncTasks = CreateProcess({
	method: "GET",
	name: "GetAsyncTasks",
	type: "ASYNCTASKS:GET",

	request: () => ({
		url: "/api/async_tasks/state",
	}),

	success: (response) => response,
});
